/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 23/07/2025 - 15:30:02
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 23/07/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../store";
import { Form, Modal } from "react-bootstrap";
import { RiCloseFill } from "react-icons/ri";
import { showTiltedTooltip } from "../../../../store/reducers/bmapSlice";
import { auth } from "../../../../firebase";
import { BsXLg } from "react-icons/bs";
import IconWrapper from "../../../../utils/IconWrapper";
import { useTranslation } from 'react-i18next';

const TiltedTooltip: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { t } = useTranslation(['mapPage', 'common']);
  const selectedArea = useSelector(
    (state: RootState) => state.bmap.selectedArea
  );
  const openTiltedTooltip = useSelector(
    (state: RootState) => state.bmap.showTiltedTooltip
  );
  useEffect(() => {
    if (selectedArea?.value === "tilted" && !openTiltedTooltip) {
      setShowTooltip(true);
    }
  }, [selectedArea]);

  const handleClose = () => {
    setShowTooltip(false);
  };

  return (
    <Modal
      show={showTooltip}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="TiltedTooltip"
    >
      <Modal.Header className="d-flex justify-content-between align-content-center border-0">
        <Modal.Title id="contained-modal-title-vcenter">
          Tilted PV Area
        </Modal.Title>
        <IconWrapper Icon={RiCloseFill} style={{ cursor: "pointer" }}
          size={30}
          onClick={handleClose} />
      </Modal.Header>

      <Modal.Body className="mt-0 pt-0" style={{ top: "0px" }}>        
        <ul className="tilted-pv-instructions">
          <li>{t('mapPage:toolTip.title')}</li>
          <li>{t('mapPage:toolTip.point1')}</li>
          <li>{t('mapPage:toolTip.point2')}</li>
          <li>{t('mapPage:toolTip.point3')}</li>
          <li>{t('mapPage:toolTip.point4')}</li>
          <li>{t('mapPage:toolTip.point5')}</li>
          <li>{t('mapPage:toolTip.point6')}.</li>
        </ul>

        <div className="d-flex justify-content-end align-items-center me-3 gap-3 pb-3 ">
          <label className="tiltedtooltipCheck" htmlFor="dont-show-checkbox">
            <Form.Check
              type="checkbox"
              id="dont-show-checkbox"
              onChange={(e) => {
                dispatch(showTiltedTooltip(e.target.checked));
              }}
            /> 
            Don't show this again
          </label>

          <p className="gotitBtn " onClick={handleClose}>
            <span>Got it</span>
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default TiltedTooltip;